// extracted by mini-css-extract-plugin
module.exports = {"container":"VehicleOwner_container__GQW54","page":"VehicleOwner_page__2fBiC","section":"VehicleOwner_section__oCqle"};